import React, { useState } from 'react';
import { Outlet, Link } from 'react-router-dom';
import styled from '@emotion/styled';

const drawerWidth = 240;

const Main = styled('main')<{ open: boolean }>(({ theme, open }) => ({
  marginLeft: open ? drawerWidth : 0,
  transition: 'margin-left 0.3s',
  padding: '16px',
}));

const ProductAdminPage: React.FC = () => {
  const [isDrawerOpen, setDrawerOpen] = useState(true);

  const toggleDrawer = () => {
    setDrawerOpen(!isDrawerOpen);
  };

  return (
    <div>
      <Main open={isDrawerOpen}>
        <Outlet /> {/* Aquí se renderiza el contenido de la página correspondiente */}
      </Main>
    </div>
  );
};

export default ProductAdminPage;
